'use strict';

let headerTab = new Tabs('.header-burger');

let zoomImg = (path) => {

    let img = `<img src="${path}" alt="Увеличенное изображение" />`;
    popup.open();
    popup.insertData(img);

}
